export default __webpack_public_path__ + "static/media/questionnaire_completed.9c48f60e.jpg";